import React from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Container } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import PageHeader from '../../../shared/components/BreadCrumb';
import Forms from './components/Forms/index';

const DetalhesDisponibilidade = () => {
  const { t } = useTranslation('common');
  const location = useLocation();
  const isPersonalizado = location.pathname.includes('/detalhesdisponibilidade/personalizado/');

  return (
    <Container>
      {!isPersonalizado && (
        <Col md={12}>
          <PageHeader
            title="PROGRAMAÇÃO"
            routeSegments={[
              { name: 'Início' },
              { name: 'Programação', path: '/pages/programacao/disponibilidade' },
              { name: 'Detalhes' },
            ]}
          />
        </Col>
      )}
      <Forms />
    </Container>
  );
};

export default DetalhesDisponibilidade;